import AuthorizedRoute from 'Components/AuthorizedRoute';
import { SITE_PAGES } from 'Config';
import withRouter from 'Lib/hoc/withRouter';
import ManageResourcesView from 'Pages/Resources/ManageResourcesView';
import ResourceDetailsPage from 'Pages/Resources/ResourceDetailsPage';
import { Route, Routes } from 'react-router';

let ResourceDetailWithRouter = withRouter(ResourceDetailsPage);

const Resources = () => {
  return (
    <Routes>
      <Route
        path=''
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.ALL_RESOURCES.requiredAuth}>
            <ManageResourcesView />
          </AuthorizedRoute>
        }
      />
      <Route
        path=':id'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.RESOURCE_DETAILS.requiredAuth}>
            <ResourceDetailWithRouter />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Resources);
export default Page;
